import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators, type Dispatch } from 'redux';
import { proxyAppAction, appError, reloadAppShell } from '../../actions';
import { getAppSettings } from '../../selectors';
import AppLoader from '../../components/AppLoader';
import type { RootState } from '../../reducers';

interface OwnProps {
  name?: string;
  onProxyAction: Parameters<typeof proxyAppAction>[0];
  [key: string]: unknown;
}

const propsToSkip: string[] = [
  'apiClient',
  'children',
  'errorLogger',
  'instance',
  'loadApp',
  'loading',
  'name',
  'onInstance',
  'trackMethod',
  'visible',
];

const pickCreationParams = (props: OwnProps): Record<string, unknown> =>
  Object.keys(props)
    .filter((key) => !propsToSkip.includes(key))
    .reduce<Record<string, unknown>>(
      (acc, key) => ({ ...acc, [key]: props[key] }),
      {}
    );

const mapStateToProps = (state: RootState, props: OwnProps) => ({
  modal: pickCreationParams(props),
  settings: getAppSettings(state),
  name: props.name || state.currentModalApp.name,
  class: cn('as-ModalApp', {
    'is-visible': state.currentModalApp.visible,
  }),
});

const mapDispatchToProps = (dispatch: Dispatch, { onProxyAction }: OwnProps) =>
  bindActionCreators(
    {
      onAppAction: proxyAppAction(onProxyAction),
      onError: appError,
      onDocumentOutdated: reloadAppShell,
    },
    (action) => action && dispatch(action)
  );

class ModalApp extends AppLoader {}

export default connect(mapStateToProps, mapDispatchToProps)(ModalApp);
